import MarkdownComponent from 'components/shared/MarkdownComponent';
import { StyledJobOfferLongText } from './JobOfferLongText.styled';

export type JobOfferLongTextType = {
  children?: string;
  isMarkdown: boolean;
};

const JobOfferLongText = ({ children, isMarkdown }: JobOfferLongTextType) => (
  <>
    {isMarkdown ? (
      <StyledJobOfferLongText>
        <MarkdownComponent content={children || ''} />
      </StyledJobOfferLongText>
    ) : (
      <StyledJobOfferLongText
        dangerouslySetInnerHTML={{ __html: children || '' }}
      ></StyledJobOfferLongText>
    )}
  </>
);

export default JobOfferLongText;
